import React, { useEffect } from 'react'
import tollGate from '../../../assets/images/Toll.png'
import AOS from "aos";
import "aos/dist/aos.css";

const Services = () => {
  useEffect(() => {
          AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: false,
            offset: 100,  // Trigger when the element is 100px from the viewport
        delay: 200, // Whether animation should happen only once
          });
        }, []);


  return (
    <div id='services'>
        <div className='text-center' data-aos="fade-up">
          <div className='flex items-center md:w-3/4 lg:w-2/4 mx-auto' >
            <img src={tollGate} alt="" className='h-12 md:h-20 w-auto mx-auto' />
            <h1 className='text-[#252525] font-bold text-2xl md:text-4xl xl:text-5xl oxygen'>Our Services !</h1>
            <img src={tollGate} alt="" className='h-12 md:h-20 w-auto mx-auto transform scale-x-[-1]'/>

          </div>
            <p className='text-[#868686] text-sm md:text-base lg:text-lg xl:text-xl px-6 md:px-12 lg:px-36 xl:px-48 my-4 md:my-8'>We offers a comprehensive range of solutions tailored to meet your needs. From personalized support to innovative strategies, we deliver quality, efficiency, and results you can trust. Whether you're seeking professional expertise or reliable assistance, we’re here to help you succeed.</p>
        </div>
    </div>
  )
}

export default Services